import { render, staticRenderFns } from "./materialDetail.vue?vue&type=template&id=3fcee676&scoped=true"
import script from "./materialDetail.vue?vue&type=script&lang=js"
export * from "./materialDetail.vue?vue&type=script&lang=js"
import style0 from "./materialDetail.vue?vue&type=style&index=0&id=3fcee676&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fcee676",
  null
  
)

export default component.exports